var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnterFullscreen = function SvgEnterFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "transparent!important"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.928 20.89h-5.774a.95.95 0 0 1-.947-.947.95.95 0 0 1 .947-.947h5.774c.645 0 1.172-.521 1.172-1.172V4.066c0-.639-.521-1.172-1.172-1.172H5.908c-.64 0-1.172.521-1.172 1.172v5.292a.95.95 0 0 1-.947.948.95.95 0 0 1-.948-.948V4.066A3.075 3.075 0 0 1 5.908 1h15.026A3.07 3.07 0 0 1 24 4.066V17.83a3.07 3.07 0 0 1-3.066 3.067l-.006-.006Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.838 8.577H11.05a.95.95 0 0 0-.947.947c0 .521.426.947.947.947h1.498l-2.167 2.167a2.898 2.898 0 0 0-1.22-.272h-6.32A2.85 2.85 0 0 0 0 15.207v5.683a2.85 2.85 0 0 0 2.841 2.841h6.315a2.85 2.85 0 0 0 2.841-2.841v-5.683c0-.438-.107-.852-.284-1.22h.012l2.166-2.166v1.492c0 .52.427.947.947.947a.95.95 0 0 0 .948-.947V9.524a.95.95 0 0 0-.948-.947ZM10.103 20.89a.95.95 0 0 1-.947.947H2.84a.95.95 0 0 1-.947-.947v-5.683a.95.95 0 0 1 .947-.947h6.315a.95.95 0 0 1 .947.947v5.683Z",
    fill: "#fff"
  })));
};
export default SvgEnterFullscreen;